
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/privacy-california",
      function () {
        return require("private-next-pages/privacy-california.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/privacy-california"])
      });
    }
  